import { schema } from "normalizr";

export const commissionSchema = new schema.Entity("commission", {});
export const arrayOfCommissionSchemas = new schema.Array(commissionSchema);
